<template>
    <div dusk="looker-embed">
        <iframe scrolling="no" ref="iframe" :style="{ width: '100%', height }" :src="embedUrl"></iframe>
    </div>
</template>

<style>
    iframe {
        border: none;
    }

</style>

<script>
export default {
    props: {
        dateRangeString: String,
        embedUrl: String,
        initialHeight: {
            type: String,
            default: '450px'
        },
        filters: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },

    data() {
        return {
            measuredHeight: null,
            iframeInitialized: false,
            iframeComplete: false,
            iframeCompletePayload: null
        }
    },

    watch: {
        dateRangeString(value) {
            this.iframeInitialized && this.refreshResultsWithNewDate(value);
        },

        filters() {
            this.iframeInitialized && this.refreshResultsWithNewFilters();
        }
    },

    mounted() {
        window.addEventListener("message", event => {
            if (event.source === this.$refs.iframe.contentWindow) {
                const data = JSON.parse(event.data);
                console.log("Looker Listener", JSON.stringify(data));

                // Dusk tests rely on these data properties to test looker
                // is behaving properly.
                if (data.type === "dashboard:run:start") {
                    this.iframeInitialized = true;
                } else if (data.type === "dashboard:run:complete") {
                    this.iframeComplete = true;
                    this.iframeCompletePayload = data.dashboard;
                } else if (data.type === "page:properties:changed") {
                    this.measuredHeight = data.height;
                }
            }
        });
    },

    computed: {
        height() {
            if (this.measuredHeight) {
                return this.measuredHeight + 'px';
            }

            return this.initialHeight;
        }
    },

    methods: {
        refreshResultsWithNewDate(dateRangeString) {
            let payloads = [{
                "type": "dashboard:filters:update",
                "filters": {
                    // Note: the api only allows one filter at a time. If you need to pass multiple filters at the same time,
                    // pass them as separate payloads.
                    "Date": dateRangeString
                }
            }];

            this.sendPayloadToIframe(payloads);
        },

        refreshResultsWithNewFilters() {
            let payloads = [{
                    "type": "dashboard:filters:update",
                    "filters": this.filters
                }];

            this.sendPayloadToIframe(payloads);
        },

        sendPayloadToIframe(payloads) {
            payloads.forEach(payload => {
                this.$refs.iframe.contentWindow.postMessage(JSON.stringify(payload), window.Portal.lookerUrl)
            });

            let runPayload = {
                type: "dashboard:run"
            }

            this.$refs.iframe.contentWindow.postMessage(JSON.stringify(runPayload), window.Portal.lookerUrl)
        }
    }
}
</script>
